import React from 'react'
import { CashInflowVSOutflowByMonth } from './CashInflowVSOutflowByMonth'
import { CashInflowVSOutflowByMonthParamsForm } from './CashInflowVSOutflowByMonthParamsForm'
import { CashLedgerListingParamsForm } from './CashLedgerListingParamsForm'
import { CashLedgerListingReport } from './CashLedgerListingReport'
import { CBDigitalReportSubmenu } from './CBDigitalReportSubmenu'
import { BankReconciliationStatementReport } from './BankRecociliationStatementReport'
import { BankReconciliationStatementParamsForm } from './BankReconciliationStatementParamsForm'
import { UserActivityLogParamsForm } from 'containers/GeneralLedgerModule/GLDigitalReportModule/Parameters/UserActivityLogParamsForm'
import { UserActivityLogReport } from 'containers/GeneralLedgerModule/GLDigitalReportModule/GeneratedReport/UserActivityLogReport'

const cbDigitalReportRoutes = [
  {
    props: {
      exact: true,
      path: '/digital-reports/cash-book',
    },
    component: <CBDigitalReportSubmenu mode="cash-book" />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/cash-book/cash-ledger-report/generated',
    },
    component: <CashLedgerListingReport />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/cash-book/cash-ledger-report/parameters',
    },
    component: <CashLedgerListingParamsForm />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/cash-book/cash-inflow-outflow-report/generated',
    },
    component: <CashInflowVSOutflowByMonth />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/cash-book/cash-inflow-outflow-report/parameters',
    },
    component: <CashInflowVSOutflowByMonthParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/cash-book/bank-reconciliation-statement-report/generated',
    },
    component: <BankReconciliationStatementReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/cash-book/bank-reconciliation-statement-report/parameters',
    },
    component: <BankReconciliationStatementParamsForm />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/cash-book/user-activity-log-report/parameters',
    },
    component: (
      <UserActivityLogParamsForm submenu="cash-book" smTitle="Cash Book" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/cash-book/user-activity-log-report/generated',
    },
    component: (
      <UserActivityLogReport submenu="cash-book" smTitle="Cash Book" />
    ),
  },
]

export default cbDigitalReportRoutes
